import styles from './style.module.scss';
import { Col, Row, Spin, Table, Typography } from 'antd';
import UIHelper from '../../../../../helpers/UIHelper';
import useStoreVsVillagePages from '../useFootfallStoreVsVillage';
import BarChangeChart from '../../../charts/barChange';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const {
    data,
    columns,
    title,
    summary,
    loading,
    searchParams,
    format,
    filters,
  } = useStoreVsVillagePages(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const byCompany = searchParams.get('by_company');
  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        {byCompany && byPeriod && byShoppingCenter && (
          <Spin spinning={loading}>
            {!allReports && (
              <Row className={styles.titleSection} justify={'center'}>
                <Col>
                  <Typography.Title level={3}>{title}</Typography.Title>
                </Col>
                <PrintFilterText
                  availableFilters={availableFilters}
                  searchParams={searchParams}
                />
              </Row>
            )}
            {allReports && (
              <Row className={styles.titleSection} justify={'center'}>
                <Col>
                  <Typography.Title level={3}>
                    FOOTFALL TREND: STORE vs VILLAGE
                  </Typography.Title>
                </Col>
              </Row>
            )}
            <br />
            <Row>
              <Col xs={24} xl={12}>
                <Table
                  columns={UIHelper.assignTire(columns)}
                  dataSource={data.tableData}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{}}
                  summary={summary}
                  loading={loading}
                />
              </Col>
              <Col span={12} className={'chartColl'}>
                <BarChangeChart
                  keys={[
                    'Incidenza Ingressi Pdv YTD',
                    'Incidenza Footfall Village YTD',
                  ]}
                  data={data}
                  format={format}
                  lineItemWidth={180}
                  itemWidth={160}
                  translateX={200}
                />
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default Print;
